export enum EUserMessages {
  cashback_increased = 'cashback_increased',
}
export const JOURNAL_REPAIR_INTERVAL = 30000
